import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import { Text } from '../../../components/Text/Text'
import { User } from '../../../models/user'
import { blueGray, midGray, primaryBlack } from '../../../theme/colors'
import { ProfileCard, ProfileCardItem } from './ProfileCard'

interface ProfilePersonalEquipmentInfoProps {
  user: User
  canEdit: boolean
}

export function ProfilePersonalEquipmentInfo({ user }: ProfilePersonalEquipmentInfoProps) {
  const history = useHistory()

  const truck = user.defaultTeamMembership?.driverAssignedTruck
  if (!truck) return null

  return (
    <>
      <ProfileCard title="Equipment">
        <ProfileCardItem leftWidth="25px" label={<TruckIcon fontSize="small" />} smallGap>
          <Text
            variant="label2"
            fontColor={primaryBlack}
            onClick={() => history.push(`/teams/${user.team}/show/equipment`)}
          >
            {truck.licensePlateNumber ? (
              <>
                {truck.licensePlateNumber} - {truck.licensePlateState}
              </>
            ) : null}
            <Text variant="label2" fontColor={midGray}>
              {truck.vehicleModel} {truck.vehicleMake} {truck.vehicleYear}
            </Text>
          </Text>
        </ProfileCardItem>
      </ProfileCard>
    </>
  )
}

const TruckIcon = styled(LocalShippingIcon)`
  margin-top: 2px;
  color: ${blueGray};
`
